// removed by extract-text-webpack-plugin
module.exports = {"newslist_item":"newsList_newslist_item_2zJUh","newsList_wrapper":"newsList_newsList_wrapper_2QrAi","newsList_wrapper_enter":"newsList_newsList_wrapper_enter_US4Ao","flex_wrapper":"newsList_flex_wrapper_CI-2y","left":"newsList_left_KY46F","right":"newsList_right_2bRPv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/widgets/NewsList/newsList.css
// module id = 332
// module chunks = 0